<div class="textarea" [ngClass]="{ 'textarea--has-label': label, 'textarea--active': value.length }">
  @if (label) {
    <label class="textarea__label" [for]="id">
      {{ label }}
      @if (required) {
        <span class="textarea__label-required">*</span>
      }
    </label>
  }
  <textarea class="textarea__main" [id]="id" [name]="name" [attr.placeholder]="placeholder" [(ngModel)]="value" (ngModelChange)="changed($event)" (focus)="touched()" [ngStyle]="{ 'height.px': height }"></textarea>
</div>
